import { Component, OnInit } from '@angular/core';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-arrangements-container',
  templateUrl: './arrangements-container.component.html',
  styleUrls: ['./arrangements-container.component.css']
})
export class ArrangementsContainerComponent implements OnInit {
  streetAddress: string;
  cityStateZip: string;
  acctNumber: string;

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService) {
  }

  ngOnInit() {
    this.loginService.getUserContext()
      .subscribe((ctx) => {
        if (ctx) {
          this.acctNumber = ctx.accountDetails[0].accountDetails.accountNumber;
          this.streetAddress = ctx.accountDetails[0].accountDetails.address1 + " " + (ctx.accountDetails[0].accountDetails.address2 !== null ? ctx.accountDetails[0].accountDetails.address2 : "");
          this.cityStateZip = ctx.accountDetails[0].accountDetails.city + ", " + ctx.accountDetails[0].accountDetails.state + " " + ctx.accountDetails[0].accountDetails.zipcode;
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/arrangements-container/arrangements-container.component.ts